/**
 * Hook misji „Nakarm pieska z miski" — tylko EMIT (W9-B / QuestLayer).
 * Czysty mapper, bez Phasera / serwera.
 */
import type { InteractEvent } from '../../interact/index.js';

export const INTERACT_BUS_EVENT = 'pieskowo:interact';
export const HOUSE_QUEST_ID = 'house_feed_dog' as const;
export const HOUSE_BOWL_DEF_ID = 'house_bowl';

export type HouseMissionPayload = {
  sceneKey: 'House';
  questId: typeof HOUSE_QUEST_ID;
  stepKind: 'feed_bowl';
  interact: InteractEvent;
};

export function isBowlFeedEvent(evt: InteractEvent): boolean {
  if (evt.defId !== HOUSE_BOWL_DEF_ID) return false;
  return (
    evt.type === 'tap' ||
    evt.type === 'consume' ||
    evt.type === 'give' ||
    evt.type === 'intention-done'
  );
}

/**
 * Payload misji po skutecznym nakarmieniu z miski.
 * Zwraca null gdy zdarzenie nie dotyczy misji.
 */
export function houseMissionFromInteract(evt: InteractEvent): HouseMissionPayload | null {
  if (!isBowlFeedEvent(evt)) return null;
  return {
    sceneKey: 'House',
    questId: HOUSE_QUEST_ID,
    stepKind: 'feed_bowl',
    interact: evt,
  };
}
